<script>
	import Layout from "../layouts/main.vue";

  	export default {
		props: {
			users_details: Array
		},
    	components: { Layout },
		data() {
			return {
				tableData: this.users_details,
				title: this.$page.props.auth.user.user_type_text + " - Global Search",
			};
		},
		computed: {
		},
		mounted() {
			$(this.$refs.global_search_table).DataTable();
		},
		watch: {
			users_details(newValue) {
				this.tableData = newValue;
				$(this.$refs.global_search_table).DataTable().destroy();
				this.$nextTick(() => {
					$(this.$refs.global_search_table).DataTable()
				})
			}
		},
  	};
</script>

<template>
	<Layout>
		<Head :title="title" />
		<!-- start page title -->
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0 font-size-18">Search Clients Or Teammates</h4>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<!-- <h4 class="card-title">Search Result For:</h4> -->
						<div class="table-responsive">
							<table class="table align-middle table-nowrap table-hover" ref="global_search_table">
								<thead class="table-light">
									<tr>
										<th scope="col" width="5%">Sl. No.</th>
										<th scope="col">Name</th>
										<th scope="col">Email</th>
										<th scope="col">Phone</th>
										<th scope="col">Account Manager</th>
										<th scope="col">User Type</th>
										<th scope="col">Action</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(user, index) in tableData" :key="user.id" track-by="user.id">
										<td>{{index + 1}}</td>
										<td>
											<a :href="user.view_url" class="text-dark">
												<div class="d-flex">
													<div class="flex-shrink-0 align-self-center me-3">
														<div v-if="user.user_photo.length == 0" class="avatar-xs">
															<span class="avatar-title rounded-circle bg-primary bg-soft text-primary">
																{{user.name | onlyFirstLetter}}
															</span>
														</div>
														<img v-else :src="user.user_photo" class="rounded-circle avatar-xs" alt="">
													</div>                                
													<div class="flex-grow-1 overflow-hidden">
														<h5 class="text-truncate font-size-14" :class="{'mb-1': user.user_company_name != null, 'mt-2': user.user_company_name == null}">
															{{user.name}}
														</h5>
														<p v-if="user.user_company_name != null" class="text-truncate mb-0">
															{{user.user_company_name.meta_value}}
														</p>
													</div>
												</div>
											</a>
										</td>
										<td>
											<a :href="'mailto:' + user.email">
												{{user.email}}
											</a>
										</td>
										<td>
											<a :href="'tel:' + user.phone_country_code + user.phone">{{ user.phone_country_code }} {{ user.phone }}
											</a>
										</td>
										<template v-if="user.parent_details != null">
											<td v-if="user.parent_details.length > 10">
												<a :href="user.others_users_url">
													{{user.parent_details | descriptionsLength(10)}}
												</a>
											</td>
											<td v-else-if="user.parent_details.length == 0">
												No Parent
											</td>
											<td v-else>
												<a :href="user.others_users_url">
													{{user.parent_details}}
												</a>
											</td>
										</template>
										<td v-else>
											N/A
										</td>
										<td>
											{{$options.filters.getUserType(user.is_emp, user.user_type, user.is_ultra_admin ? user.is_ultra_admin : null)}}
										</td>
										<td>
											<ul class="list-inline font-size-20 contact-links mb-0">
												<li class="list-inline-item px-2">
													<a :href="user.view_url" title="View Details"><i class="bx bx-show-alt"></i></a>
												</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
